import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { ATTENDANCE_QUERY_KEYS } from './keys';

import { fetchSummary } from 'services/attendance';
import type { QueryObject } from 'interface/queryParam';

type AttendanceSummaryFilter = QueryObject & {
  fetchType?: string;
  userId?: string;
  startDate?: string;
  endDate?: string;
};

interface AttendanceSummaryResponse {
  data: Record<string, number | Record<string, number> | null>;
}

export function useFetchAttendanceSummary(
  filter: AttendanceSummaryFilter,
  shouldFetch = true
): UseQueryResult<AttendanceSummaryResponse, Error> {
  return useQuery<AttendanceSummaryResponse, Error>({
    queryKey: [ATTENDANCE_QUERY_KEYS.SUMMARY, filter],
    queryFn: () => fetchSummary(filter) as unknown as Promise<AttendanceSummaryResponse>,
    enabled: shouldFetch && Boolean(filter.fetchType),
  });
}
